import { Box, Typography } from '@mui/material';
import { keyframes, styled } from '@mui/system';
import Lottie from 'lottie-react';
import ERROR_LOTTIE from '../services/close.json';
import Constant from '../services/Constant';
// Animations
const appearIn = keyframes`
  0% { opacity: 0; transform: scale(0.97) translateY(40px); }
  100% { opacity: 1; transform: scale(1) translateY(0); }
`;

const floatPulse = keyframes`
  0%, 100% { box-shadow: 0 2px 32px rgba(0,151,178,0.20); }
  50% { box-shadow: 0 6px 48px rgba(8,85,127,0.19); }
`;

const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

const GradientBackground = styled(Box)({
    position: 'absolute',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: Constant.COLOR_PALLETE.background.gd, backgroundSize: '200% 200%',
    animation: `${gradientMove} 15s alternate infinite`,
});

const CardContainer = styled(Box)({
    maxWidth: '640px',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '24px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
    padding: '3rem 2.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
    animation: `${appearIn} 1.2s cubic-bezier(.47,1.64,.41,.8) both`,
    zIndex: 10,
    position: 'relative',
});

const PulseCircle = styled(Box)({
    width: '144px',
    height: '144px',
    borderRadius: '50%',
    background: `linear-gradient(to top right, white, ${Constant.COLOR_PALLETE.background.secondary}, white)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: `${floatPulse} 3.5s ease-in-out infinite`,
    position: 'relative',
});

const VerifiedBadge = styled(Box)({
    position: 'absolute',
    bottom: '-16px',
    right: '-8px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: `linear-gradient(to top right, white, ${Constant.COLOR_PALLETE.background.secondary}, white)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid white',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
});

const ForgotPassowrdTokenExpired = () => {
    return (
        <Box sx={{ height: '100vh', position: 'relative', overflow: 'hidden' }}>
            <GradientBackground>
                <CardContainer>
                    {/* Logo Header */}
                    <Box sx={{ mb: 3 }}>
                        <img src={"/logo.png"} alt="" />
                    </Box>

                    {/* Lottie + Message */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <PulseCircle>
                            <Lottie
                                animationData={ERROR_LOTTIE}
                                style={{ width: 250, height: 250 }}
                            />
                            <VerifiedBadge>
                                <Lottie
                                    animationData={ERROR_LOTTIE}
                                    style={{ width: 32, height: 32 }}
                                />
                            </VerifiedBadge>
                        </PulseCircle>

                        <Typography variant="h4" fontWeight={800} textAlign="center" color="text.primary" sx={{
                            paddingTop: '10px',
                            fontFamily: 'DM Sans',
                        }}>
                            Your Token has expired
                        </Typography>
                        <Typography variant="body1" textAlign="center" maxWidth={400} color="text.secondary">
                            Please request a new password reset link to continue.
                        </Typography>
                    </Box>
                </CardContainer>
            </GradientBackground>
        </Box>
    );
};

export default ForgotPassowrdTokenExpired;
